import { usePathname } from 'next/navigation';
import { headerLinks } from '@/components/Nav/data';
import { Route } from 'next';

export interface ISubItem {
  name: string;
  description: string;
  href: Route;
}

export interface ISubNav {
  name: string;
  items: ISubItem[];
}

type INavLink = {
  name: string;
  items?: never;
  href: Route;
};

export type INavChild = {
  name: string;
  items: ISubNav[];
  href?: never;
};

export type INav = INavLink | INavChild;

export function isNavWithChild(nav: INav): nav is INavChild {
  return 'items' in nav && Array.isArray(nav.items);
}

export const useCurrentPath = () => {
  const currentPath = usePathname();
  const path = currentPath.includes('/blog/') ? '/blog' : currentPath;

  if (path === '/') {
    return;
  }

  for (const base of headerLinks.filter(isNavWithChild)) {
    for (const category of base.items) {
      const current = category.items.find(({ href }) => href === path);

      if (current) {
        return {
          doubleDeckerLinks: category.items.map(({ name, href }) => {
            return {
              name,
              href,
            };
          }),
          doubleDeckerKey: category.items.map(({ name }) => name).join(),
          href: current.href,
          baseName: base.name,
        };
      }
    }
  }
};
